import React from "react";

const Guar = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Guar</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>HG - 365 [Released in 15.05.1998]</strong>
              </td>
            </tr>
            <tr>
              <td>8-9 kgs per acre.</td>
              <td>Mid July is suitable time for sowing.</td>
              <td>
                In drought conditions, one irrigation is must at the time of
                fruiting.
              </td>
              <td>90-95 days.</td>
              <td>
                Resistant to lodging and pod shuttering. Resistant to most
                bacterial blight and most insects.
              </td>
              <td>7-8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>RGC - 936 [Released in 22.11.1991]</strong>
              </td>
            </tr>
            <tr>
              <td>8-9 kgs per acre.</td>
              <td>Mid July is suitable time for sowing.</td>
              <td>
                If there is no rain then make sure to irrigate once when the
                seeds start to appear.
              </td>
              <td>Early maturing variety</td>
              <td>Suitable for all over India.</td>
              <td>8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HG - 563 [Released in 31.05.2004]</strong>
              </td>
            </tr>
            <tr>
              <td>8-9 kgs per acre.</td>
              <td>Mid July is suitable time for sowing.</td>
              <td>
                If there is no rain then make sure to irrigate once when the
                seeds start to appear.
              </td>
              <td>Early maturing variety.</td>
              <td>
                Suitable for all Guar growing areas. Plant has a more branches.
              </td>
              <td>7-8 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Guar;
